export default {
  // common
  common: {
    'subscription-modal': {
      header: 'Enable mobile payments',
      title: 'Unlock mobile payments',
      description: 'Checkout your clients without leaving the app! Mobile Payments isn\'t available for trial users, to get started first select your Booksy subscription plan.',
      subscribe: 'Subscribe to booksy',
      cancel: 'Thank you, not now',
    },
  },
  // dashboard
  dashboard: {
    title: 'Your Account',

    tabs: {
      'bank-account': 'Bank Account',
      'personal-details': 'Personal Details',
      'company-details': 'Company Details',
      'business-owners': 'Business Owner(s)',
    },

    mode: {
      individual: 'Individual',
      business: 'Business',
    },

    'change-type': {
      title: 'Your Account Type',
      cancel: 'No changes in my business type',
      individual: {
        text: 'Your account type is currently an Individual. Are you about to change your account type to Business? The personal details you entered will be lost in this process. Do you want to continue?',
        switch: 'Switch to Business',
      },
      business: {
        text: 'Your account type is currently Business. Are you about to change your account type to an Individual? The personal details you entered will be lost in this process. Do you want to continue?',
        switch: 'Switch to Individual',
      },
    },

    'placeholder': {
      title: 'Now let\'s verify your identity.',
      description: 'This will allow us to get you set up for payouts.',
    },

    'account-status': 'Account Status',
    'account-status-copy': {
      default: 'Verified account will allow you to set up for payouts.',
      active: 'Your payments set up is complete. We\'ll send payouts to the account on file.',
      pending: 'We\'re reviewing your information. Account verification could take up to one business day.',
      blocked: 'We weren\'t able to verify your account, please correct your documentation to take advantage of payments.',
    },
    'not-verified': 'Not Verified',

    'payout-status': 'Payout Status',
    'change-account-type': 'Change Account Type',

    'verify-account': 'Verify Account',

    'home-address': 'Home Address',
    'business-address': 'Business Registration Address',

    'upload-modal': {
      'looks-good': 'Looks Good',
      'choose-another': 'Choose Another',
      retake: 'Retake',
      'cropper-description': 'Is the photo clear and legible? Crop or zoom with multi-touch gesture. Position your photo by drag and dropping it.',
      description: 'Upload a document in the following formats: .pdf, .jpg, .jpeg, .png.',
      'description-with-capture': 'Center your document in the on-screen frame, make sure you have good lightning - darker background, light in front of you. Our software will read the data better and process it faster. Alternatively, you can upload a document in the following formats: .pdf, .jpg, .jpeg, .png.',
    },

    'upload-identity': {
      section: 'Identity Verification',
      title: 'Proof of identification',
      description: 'Please upload one of the below documents as proof of identification. You must provide a valid ID with more than one month remaining until expiration. Accepted file formats include: .pdf, .jpg, .jpeg, and .png',
      modal: {
        tips: 'Tips: Center the image and use good lighting to ensure the image is clear. This will allow for faster processing.',
        description: {
          front: 'Please upload a picture of the front of your document which will be used only for verification purposes.',
          back: 'Please upload a picture of the back of your document which will be used only for verification purposes.',
          all: 'Please upload a picture of the document which will be used only for verification purposes.',
        },
      },
      'identity-card': {
        option: 'National Identity Card',
        front: 'Front of National Identity Card',
        back: 'Back of National Identity Card',
      },
      'drivers-licence': {
        option: 'Drivers Licence',
        front: 'Front of Drivers Licence',
        back: 'Back of Drivers Licence',
      },
      passport: {
        option: 'Passport',
        front: 'Passport',
      },
      'success-splash': {
        title: 'Completed',
        subtitle: `Nice!<br>
        The photo of your document was uploaded successfully. We will send you an email notification once your account is verified.`,
      },
      'photo-added': 'Photo added!',
    },

    'bank-statement': 'Bank Statement',
    'upload-bank-statement': 'Upload Bank Statement',

    'company-verification': 'Company Verification',
    'business-registration-document': 'Business Registration Document',

    'company-verification-modal': {
      description: 'Please provide proof of business registration. This must be a formal legal document and company details must match those associated with your Booksy account. <br><br>You can take a photo or upload a document in the following formats: .pdf, .jpg, .jpeg, and .png.',
    },

    'bank-statement-modal': {
      title: 'Bank Statement Verification',
      description: 'Send us a photo of your bank statement with a visible bank logo. Make sure the photo you upload includes the name of the account holder, billing address and bank account number. These bank details must match the ones you provided in the form.<br/><br/>Following photo formats are<br/>accepted: .pdf, .jpg, .jpeg, .png.',
    },

    'add-owner': 'Add Business Owner',
    'personal-details': 'Personal Details',
    'personal-details-with-name': '{name}\'s Personal Details',

    'delete-owner': {
      title: 'Delete Business Owner?',
      text: 'Are you sure you want to remove the business owner? All the collected data will be deleted.',
      yes: 'Yes, delete anyway',
    },
  },
  'fast-payouts': {
    drawer: {
      title: 'Fast Payout',
      'payout-form': 'Fast Payout',
      'payout-history': 'Payout History',
    },
    'first-time-screen': {
      'instant-payouts': {
        'sub-title': 'With Fast Payouts, you can send funds to your debit card, and get your money within 30 minuts, including weekends and holidays.',
        title: 'Fast Payouts - get paid, right now.',
      },
      'seamless-payouts': {
        'sub-title': 'Payments taken through Booksy Card Reader are accrued throughout the day and are paid out to your account within 2-3 business days. If you need your deposit right away, try Fast Payout.',
        title: 'Your money. More options.',
      },
      'money-on-the-go': {
        'sub-title': 'Fast Payouts are completely integrated with Booksy Card Readers. You decide how much of your balance to Fast Payout, and use built-in reporting to track your income.',
        title: 'You\'re in control',
      },
      'no-hidden-costs': {
        'sub-title': 'Transparent rates, no monthly fees. You only pay when you withdraw money.',
        title: 'No Hidden Costs',
      },
      'legal-terms': {
        info: 'The payout fee is an additional fee charged in addition to the booksy card reader fees. You can read more in ',
        'terms-and-conditions': 'Terms & Conditions',
      },
      'stripe-terms': {
        info: 'By clicking "Get Started" you are agreeing to the ',
        'terms-and-conditions': 'Stripe Terms & Conditions',
      },
      'get-started': 'GET STARTED',
    },
    'fast-payout': 'Fast Payout',
    form: {
      amount: 'Amount',
      'cancel-payout': {
        'confirm': 'Exit process',
        'info': 'Fast Payout will not be sent if you exit here',
        'title': 'Exit process?',
      },
      'bank-account': 'Account number',
      'bank-account-error': 'Account number is not supported',
      'card-info': 'Fast Payouts are directed to the debit card provided during the Stripe registration process. If you would like to change this information, you can do so under Booksy Card Reader settings.',
      'new-kyc-card-info': 'To update your payout card details, find the Payout method section and click the three dots for more options, then select Go to Payout settings.',
      'complete-payout': 'Complete Payout',
      'confirm-payout': 'Confirm Fast Payout of<br>{amount}?',
      'deposit-amount': 'Deposit Amount',
      description: 'Description',
      'destination-card': 'Destination debit card number',
      'destination-account': 'Destination account number',
      'errors': {
        'amount-too-low': 'The deposit amount can\'t be less than {amount}',
        'amount-too-high': 'The value of deposit may not exceed the actual balance available',
        'amount-over-limit': 'The value of the deposit cannot exceed the maximum withdrawal limit',
      },
      'fast-payout-details': 'Fast Payout details',
      'fee-info': 'The payout fee is {fee} of the amount paid out.',
      'payout-confirmed': {
        'info': 'Funds typically appear in the associated bank account within 30 minutes.',
        'title': 'Fast Payout confirmed',
      },
      'payout-unavailable': {
        'info': 'Please try again in a little while',
        'title': 'Fast Payouts are unavailable right now',
      },
      'payout-went-wrong': {
        'info': 'Try to make the deposit again',
        'title': 'Oh no, something went wrong',
      },
      'remaining-balance': 'Remaining Balance',
      'try-again': 'Try again',
      'unsupported-card-info': 'Debit card not supported for Fast Payouts',
      'add-valid-card': 'Please enter a valid debit card number',
      'add-valid-bank-account': 'Please enter a valid bank account number',
      'not-available-alert': 'Fast Payouts are not currently available for you. To unlock them, keep using Booksy Payments. Check back once you have used Booksy a little more to see if you have become eligible.',
    },
    'how-it-works': {
      title: 'How it works',
      'fast-payouts': 'Fast payouts',
      'fast-payouts-1': 'With Fast Payouts, you can send funds to a connected account\'s <strong>supported debit card</strong> within 30 minutes, including weekends and holidays. Fast Payouts can only be initiated once per day, and must be initiated before Midnight UTC.',
      'fast-payouts-account-1': 'With Fast Payouts, you can send funds to a <strong>supported bank account</strong> within 30 minutes, including weekends and holidays. Fast Payouts can only be initiated once per day, and must be initiated before Midnight UTC.',
      'payments': 'Payments',
      'payments-1': 'All payments you collect on Booksy Payment Solutions add to your Balance',
      'payments-2': 'Fast Payout must be initiated before Midnight UTC. You can transfer any amount up to your available payout balance, or up to the {amount} daily limit.',
      'payments-3': 'Any funds not transferred via Fast Payouts by that time each day will be automatically deposited to your account the next business day via our Standard Payout process (no fee applied).',
      'payments-4': 'Fast Payout can only be initiated once per day.',
      'payments-5': 'Once Instant Payout has been initiated, it can’t be aborted, canceled or reverted.',
      'payments-6': 'Each Fast Payout is charged a {fee} fee of the amount being transferred. Any funds not paid out with Fast Payouts will be deposited in 2-3 business days with no fee.',
      'troubleshooting': 'Troubleshooting',
      'troubleshooting-1': {
        message: 'If you experience issues using Fast Payouts, {url} to see if your debit card is supported.',
        'message-account': 'If you experience issues using Fast Payouts, {url} to see if your bank account is supported.',
        url: 'check here',
      },
      'troubleshooting-2': 'If you want to increase your daily Fast Payout limit, you can do so in your Card Reader settings',
      'troubleshooting-3': 'You can set your own daily Fast Payout limit by going to Payments & Checkout > Payout Settings > Fast Payouts.',
      'limits': 'It must be between {lowAmount} and {highAmount}.',
    },
    settings: {
      'account-details': {
        title: 'Account details',
        'daily-payout-limit-too-low': `The daily payout limit can't be less than {value}`,
        'daily-payout-limit-too-high': `The daily payout limit can't be greater than {value}`,
        description: `
          A Fast Payout will be sent to the debit card provided during the application process, and here below.
          Funds should appear in your account up to 30 minutes after initiating the Fast Payout. If you would
          like to change the debit card for future Fast Payouts, update your details by clicking on the button
          at the bottom the screen.
        `,
        form: {
          'card-holder': 'Card Holder\'s Name',
          'card-destination': 'Destination Debit Card Number',
          'card-info': 'Fast Payouts are sent to the debit card provided during Stripe registration. To update your payout info, click Update Account Details below',
          'card-expiration-date': 'Expiration Date',
          'account-holder': 'Account Holder\'s Name',
          'account-number': 'Account Number',
          'bank-info': 'Fast payouts are directed to the account you provided during the Stripe registration process. If you would like to change these details, you can do so in the Stripe form by clicking on Update Payout Details.',
          'bank-name': 'Bank Name',
          'bank-routing-number': 'Routing Number',
        },

        'update-button': 'Update Account Details',
        'unsupported-bank-account-info': 'The account number provided in the registration process is not supported. At this time, we only support debit card. Please update your details to take advantage of the instant payout feature',
        'unsupported-card-info': 'The card provided in the registration process is not supported by the service. Please choose a different card number and update your details to enjoy the instant payment functionality.',
      },
      'fast-payout-status': {
        title: 'Fast Payout',
        descriptions: {
          'verified': 'You’re ready to use Fast Payouts. Go to the Profile screen, and tap the Fast Payout card to start a Fast Payout. Payouts will be sent to the provided debit card.',
          'blocked': 'The setup of the instant payout system has been completed. Payouts will be sent to the card number, which is in the system.',
        },
        statuses: {
          'verified': 'Verified',
          'blocked': 'Blocked',
        },
      },
      'payout-details': {
        title: 'Payout details',
        form: {
          allowed: {
            title: 'Fast Payout Allowed',
            description: 'Enables Fast Payouts to be initiated from the Profile screen',
          },
          blocked: {
            description: 'Enables Fast Payouts to be initiated from the Profile screen',
          },
          limit: {
            title: 'Max daily withdraw limit',
            description: 'Daily payout limit may range from {from} to {to}',
          },
        },
      },
      'payout-status': {
        title: 'Payout status',
        statuses: {
          allowed: 'Allowed',
          'not-allowed': 'Not allowed',
          'active': 'Active',
          'inactive': 'Inactive',
        },
      },
      title: 'Fast Payout',
    },
    summary: {
      'deposit-card': 'Deposit Card Number',
      'card-number': 'Card Number',
      'card-issuer': 'Card Issuer',
      'item': 'Item',
      'fast-payout': 'Fast Payout',
      'subtotal': 'Subtotal',
      'taxes-fees': 'Taxes & Fees',
      'taxes-fees-subtitle': 'Immediate withdrawal fee including taxes',
      'total': 'Total payout amount',
      'value': 'Value',
    },
    tile: {
      'booksy-card-reader': 'Booksy Card Reader',
      title: 'Available for Fast Payout',
      descriptions: {
        'available': 'Money in 30 minutes. You decide how much of your balance to pay out.',
        'available-tomorrow': `Your daily Fast Payout limit has been reached. Next availability for Fast Payout will be on {date}.`,
        'blocked': 'Fast payouts are currently blocked. Please contact our support team for assistance.',
        'complete-first-transaction': 'Start using your Booksy Payment Solutions, and treat yourself to Fast Payouts. Your money, within 30 minutes.',
        'missing-kyc': 'Fast, secure payment processing for credit cards and mobile wallets.',
        'wrong-bank-account': 'Bank account details are not supported for Fast Payouts. Please update your payout method with a debit card to use Fast Payouts.',
        'wrong-debit-card': 'The debit card specified is not supported for Fast Payouts. Please update your payout card with a different debit card.',
        'missing-payout-method': 'A valid debit card is required to enable Fast Payouts. Please update your payout methods in Account Verification settings',
      },
      buttons: {
        'available': 'Fast payout',
        'available-tomorrow': 'Fast payout',
        'complete-first-transaction': 'Fast payout',
        'contact-support': 'Contact with support',
        'continue': 'Continue',
        'read-more': 'Read more',
        'start-using': 'Start using Card Reader',
        'update-payout-method': 'Update payout method',
      },
    },
  },
  // kyc
  kyc: {
    continue: 'Continue',
    'information-description': 'Identity verification is intended to protect you. We want to make sure that we\'re sending your payouts to a secure place.<br><br>Please have a recent bank statement on hand along with your current address, Tax ID number (aka SSN), and a photo ID. This will help us match your identity to your bank account.',
    'information-description-gb': 'We need a safe place to send your payouts! Have your bank statement on hand to provide correct account details.<br><br>To verify your identity, have your current address, ID, and company registration documents ready. Identity details must match the name of the bank account holder.',
    'business-registration-address': 'Business Registration Address',
    'add-business-owner': 'Add Business Owner (optional)',
    'company-details-header': 'Please provide your business information. This should match your business registration documents.',
    exit: {
      title: 'Exit Setup?',
      text: 'You\'re about to exit the {change_mode} Account setup. Your account will continue to be set to {current_mode} and no changes will be made to your banking information. Are you sure you want to proceed?',
      confirm: 'Yes, exit',
    },
    steps: {
      'account-verification': 'Account Verification',
      'home-address': 'Home Address',
    },
    'business-owners': {
      'form-header': 'Provide the details of the business owner who owns at least 25% of the shares. You may be asked to upload a photo of the ID.',
      'list-header': 'Add any additional business owners who own at least 25% of the business shares.',
      delete: 'Delete Business Owner?',
      'delete-text': 'Are you sure you want to remove the business owner? All the collected data will be deleted.',
      'delete-anyway': 'Yes, delete anyway',
      'back-anyway': 'Yes, go back anyway',
      reject: 'Oops, no',
      'go-back': {
        title: 'Go Back to Company Details',
        text: 'The personal details you entered here will be lost in this process. Do you want to continue?',
      },
    },
    'common': {
      header: 'Please make sure your personal information matches what\'s listed on your bank statements.',
      footer: 'This information is only used for account verification and payouts. It will not be visible on your profile or shared with anyone.',
    },
    'account-type': {
      saving: 'Savings',
      checking: 'Checking',
    },
    hints: {
      'account-holders-name-title': 'Verifying the account holder',
      'account-holders-name-desc-europe': 'You can find an account holder’s name on your Bank Account Statement.',
      'account-holders-name-desc': 'The name of the account holder is listed on the check.',
      'account-number-title': 'Where\'s my account number?',
      'account-number-desc': 'Your account number is the second series of numbers on your check.',
      'routing-number-title': 'Where\'s my routing number?',
      'routing-number-desc': 'Your routing number is the first series of numbers on your check.',
      'legal-business-name-title': 'What is legal business name?',
      'legal-business-name-desc': 'A legal business name must match the account holder’s name to confirm who the account belongs to.',
      'iban-title': 'What is IBAN?',
      'iban-desc-pl': 'You can find and IBAN number on bank statement. The IBAN number consists of 28 digits. Example format is PL10105000997603123456789123',
      'iban-desc-gb': 'Sort Code and Account Number are not supported. You can find and IBAN number on bank statement. The IBAN number consists of 22 digits. Example format is GB33BUKB20201555555555',
    },
    done: {
      'restricted-access': 'Completed',
      'restricted-access-subtitle': 'Your account is being verified. It may take up to one business day. We will let you know when it is completed and mobile payments are enabled.',
      'access-pending': 'Account Verification Pending',
      'access-pending-subtitle': 'Your account is waiting for verification. It may take up to one business day. If after this time you are unable to access the payments module, please contact us.',
      'almost-there': 'Almost there!',
      'kyc-europe-subtitle': 'The law obliges us to verify your identity before enabling mobile payments. To complete the verification, upload the ID document and Bank Statement in Your Account section. <br><br>The verification process may take up to one business day.',
    },
    start: {
      title: `Identity verification is intended to protect you. We want to make sure that we're sending your payouts to a secure place.`,
      description: 'Please have a recent bank statement on hand along with your current address, Tax ID number (aka SSN), and a photo ID. <br><br>This will help us match your identity to your bank account.',
    },
  },
  'kyc-stripe': {
    'account-details': 'Account Details',
    'payout-settings': 'Payout Settings',
    'payout-limit': {
      title: 'Set payout limit',
      description: 'Daily minimum payout is {minLimit}. Daily max is {maxLimit}.',
    },
    'no-payout': {
      title: 'No payout method added',
      description: 'Add a payout method to receive funds.',
      action: 'Add payout details',
    },
    'no-payout-bank': {
      title: 'No payout method added',
      description: 'Add bank account to receive funds from payouts.',
      action: 'Add bank account',
    },
    'payout-details': {
      title: 'Payout Details',
      action: 'Update Payout Details',
    },
    'remove-method': 'Remove {method}',
    'remove-method-account': 'Remove account',
    'remove-method-card': 'Remove card',
    'standard-payout-toggle': 'Use this {method} for standard payouts',
    'standard-payout-toggle-account': 'Use this bank account for standard payouts',
    'standard-payout-toggle-card': 'Use this card for standard payouts',
    'fast-payout-toggle-account': 'Use this bank account for fast payouts',
    'fast-payout-toggle-card': 'Use this card for fast payouts',
    'bank-account': {
      title: 'Bank Account',
      description: 'This bank account will receive funds from standard payouts.',
      'account-number': 'Account Number: {number}',
      'routing-number': 'Routing Number: {number}',
      'sort-code': 'Sort Code: {number}',
      'iban-number': 'IBAN number',
      'delete-modal': {
        title: 'Remove this bank account?',
        text: 'You will no longer be able to receive payouts to this account once removed. Are you sure you want to remove it?',
      },
      'cannot-delete-modal': {
        title: 'Bank account could not be removed',
        text: 'Bank accounts cannot be removed if they are your only or default payout method. <br><br> Please add another payout method in order to remove this bank account.',
      },
    },
    'debit-card': {
      title: 'Debit Card',
      description: 'This debit card can receive funds for Fast Payouts and standard payouts.',
      'expire-date': 'Valid: {date}',
      modals: {
        preview: {
          title: 'Debit card details',
          'card-number': 'Card number',
          'expiration-date': 'Expiration date',
          'fast-payout-toggle': 'Use this card for fast payouts',
        },
        add: {
          'title': 'Add debit card',
        },
        'delete': {
          title: 'Remove this card?',
          'text-fast-payouts': 'As this is your only debit card, you will no longer be able to receive <strong>Fast Payouts</strong> if you remove it.<br><br> Are you sure you want to remove it?',
          text: 'You will no longer be able to receive payouts to this card once removed. Are you sure you want to remove it?',
        },
        'cannot-delete': {
          title: 'Card could not be removed',
          text: 'This card cannot be removed as it is your only current payout method.<br><br> Add a new debit card or bank account to receive payouts to in order to remove this card.',
        },
      },
    },
    'remove': 'Remove',
    'max-daily-fast-limit': 'Max daily Fast Payout limit',
    'for-further-information-update': 'For further information, please go to Update details.',
    'stripe-redirect-info': 'To update your details you will be redirected to Stripe.',
    'redirection-loading-info': 'You are being redirected to the Stripe website',
    'account-verification': 'Account verification',
    'payout-status': 'Payout status',
    'fast-payout-status': 'Fast payout status',
    'fast-payout': 'Fast Payout',
    'standard-payout': 'Standard Payout',
    'error': 'Error',
    'inactive': 'Inactive',
    'business-type': 'Business type',
    'personal-details': 'Personal Details',
    'business-details': 'Business Details',
    'full-name': 'Full name',
    'date-of-birth': 'Date of birth',
    'ssn': 'SSN',
    'company-name': 'Company name',
    'tax-id': 'Tax ID',
    'provide-information-hint': 'You’ll need to provide the information once your payout balance reaches {value}',
    'stripe-redirect-hint': 'To process transactions through our payment processor, your account needs to be verified. The data you provide is secure and only used so we can make sure your money gets to the right place.',
    'update-details': 'Update Details',
    'stripe-account-business-type': {
      'individual': 'Individual',
      'company': 'Company',
      'non-profit': 'Non-profit',
      'government-entity': 'Government entity',
    },
    status: {
      verified: {
        title: 'Verification complete',
        description: 'Now you\'re able to start using Booksy Payment Solutions.',
        action: {
          'add-payout-details': 'Add Payout Details',
          'maybe-later': 'Maybe later',
        },
      },
      'verification-pending': {
        title: 'Your account is being verified',
        description: 'It may take up to one business day',
        action: {
          'update-account-details': 'Update Account Details',
        },
      },
    },
    'bank-account-form': {
      'title': 'Add bank account',
      'routing-number': 'Routing number',
      'routing-number-hint-title': 'Where\'s my routing number?',
      'routing-number-hint-desc': 'Your routing number is the first series of numbers on your check or bank statement.',
      'sort-code': 'Sort code',
      'account-number': 'Account number',
      'account-number-hint-title': 'Where\'s my account number?',
      'account-number-hint-desc': 'Your account number is the second series of numbers on your check or bank statement.',
      'confirm-account-number': 'Confirm account number',
      'for-standard-payouts': 'Use this account for standard payouts',
      'bank-account-details': 'Bank account details',
      'hint-standard-payouts': 'You must select at least one account or card to receive standard payouts.',
      'remove-bank-account': 'Remove bank account',
      'verifying': 'Verifying',
      'currency-info': 'Payouts will be processed in {currency} - currency configuration information <a href="https://stripe.com/docs/connect/bank-debit-card-payouts#supported-settlement"><strong>here</strong></a>.',
    },
    'iban-hint': {
      title: 'Where\'s my IBAN number?',
      description: 'You can find IBAN (24-digit number) on your Bank Account Statement. For example: FR5000997603123456789123',
    },
    'bank-account-preview': 'Bank account details',
    'preview-info': 'You must select at least one account or card to receive standard payouts.',
    'payout-method-added': 'Payout method added',
    'payout-method-saved': 'Payout method saved',
    'add-new-bank-account': 'Add New Bank Account',
    'add-new-debit-card': 'Add New Debit Card',
    'add-payout-details': 'Add Payout Details',
    'add-payout-details-desc': 'Add bank account to receive funds from standard payouts or debit card for Fast Payouts and standard payouts.',
    'account-verification-label': {
      'turned-off': 'Turned Off',
      'verification-pending': 'Verification Pending',
      'verified': 'Finished',
      'not-verified': 'Not Verified',
    },
  },
  // payment-types
  'payment-types': {
    'content-slider': {
      header: 'Enable mobile payments',
      buttonCaption: 'Get Started',
      slide1: {
        title: 'Streamline Checkout',
        description: 'Accepting payments via the app is easy and secure.',
      },
      slide2: {
        title: 'Reduce No-Shows',
        description: 'Use Deposits and Cancellation Fees to encourage your clients to show up.',
      },
      slide3: {
        title: 'Full Transparency',
        description: 'Stay organized with your payments dashboard and get full transparency with Payout Reports.',
      },
      'terms-adyen': 'By clicking "Get Started" you are agreeing to the <a href="{adyenTermsUrl}" target="_blank"><strong>Payments Terms of Service</strong></a> and <a href="{adyenActionsUrl}" target="_blank"><strong>Prohibited Actions</strong></a>.',
      'terms-stripe': 'By clicking "Get Started" you are agreeing to the <a href="{stripeTermsUrl}"><strong>Stripe Terms and Conditions</strong></a>.',
    },

    main: {
      header: 'Payment Methods',
    },

    status: {
      'inactive': 'Turned Off',
      'pending': 'Pending',
      'blocked': 'Blocked',
      'active': 'Active',
    },

    'mobile-restricted': {
      title: 'Restricted Access',
      subtitle: 'Your payment functionalities are currently disabled, so you do not have access to the Payments & Checkout menu.<br><br>To enable payments for your account, please contact our Support Team.',

      'button-contact': 'Contact customer support',
      'button-later': 'Maybe later',
    },

    'customer-service-text': 'We are working on Mobile Payments for you … <br><br>Our Customer Service is on that. We will contact you soon to get more details about your business. ',

    'mobile-success': {
      title: 'Congratulations',
      subtitle: `You’ve just set up Mobile Payments!<br/>
      Now, turn on Deposits.<br/><br/>
      Apply a 50% Deposit to protect yourself against no-shows and recover lost revenue.<br/><br/>
      We'll ask your client to keep their card and prompt them to pay 50% of the total service price upon booking.<br/><br/>
      `,
      'button-protection': 'Go to deposits options',
      'button-noprotection': 'I don\'t need protection',
    },

    modals: {
      'activated': 'Mobile Payments Activated!',
      'activated-text': 'You can now enforce your Cancellation and No-Show policies for selected services. Head to Business Settings to set your rules.',
      'action-required': 'Further Action Required',
      'action-required-text': 'It looks like we need a bit more information to get you set up on Mobile Payments. Please take a couple moments to verify your account and confirm all information is correct.',
    },

    migration: {
      header: 'MOBILE PAYMENTS VERIFICATION',
      title: 'Account details verification',
      'description-top': 'It’s a commitment to safety required by Anti Money Laundering to verify your account and further process mobile payments.<br/> After verifying your account you’ll:',
      'description-list': '• Have full transparency with Payout Reports<br> • Be able to give refunds for up to 30 days<br> • Get Booksy’s help fighting any chargebacks<br>',
      'description-bottom': 'In the unlikely event one of your clients opens a dispute with their bank you\'ll be be responsible for a $15 non-refundable chargeback fee.',
      'terms': 'Read <a href="https://www.adyen.com/legal/terms-and-conditions" target="_blank">Payments Terms of Service</a> and <a href="https://www.adyen.com/legal/list-restricted-prohibited" target="_blank">Prohibited list</a>',
    },
  },
  // square
  square: {
    tile: {
      title: 'Square Card Reader',
      subtitles: {
        'turned-off': 'To start processing payments using Square install the Square app on your device and secure a card reader.',
        'app-required': 'Please install the Square Point of Sale app on your device to process payments via Square.',
        active: 'You’re set up to use Square which is integrated with your Booksy checkout experience.',
      },
      statuses: {
        'turned-off': 'Turned Off',
        'app-required': 'App Required',
        active: 'Active',
      },
      'turn-on': 'Turn on',
      'turn-off': 'Turn off',
    },
    modals: {
      enable: {
        title: 'Get Started with Square',
        text: 'To begin processing payments using Square please secure a card reader and download the Square Point of Sale app to your device.<br><br>Once you’re set up initiate your Checkout process on Booksy and then choose Square as your payment method. We’ll route you appropriately to and from the Square app so that you can continue to move through your day with ease.<br><br>Please note Square’s standard processing fees will apply to every transaction. Consult their website for current rates.',
        button: 'Enable Square',
      },
      'get-app': {
        title: 'Get the Square App',
        text: 'To begin processing payments using Square please download the Square Point of Sale app to your device. You’ll also need to have a card reader connected.',
        'button-download': 'Download Square',
        'button-close': 'Not now',
      },
      disable: {
        title: 'Disable Square?',
        text: 'Do you want to disable Square payments? Once disabled, Square won’t listed as a payment option during checkout. You can add it back anytime.',
        button: 'Disable Square',
      },
      'first-time': {
        title: 'You’re being redirected to Square',
        text: 'After completing your transaction on Square tap on the New Sale button to return to Booksy.',
      },
    },
    'pending-transaction': {
      title: 'Action required',
      content: 'Something went wrong and we weren’t able to verify your last transaction. Please check you Square app and confirm whether or not you received payment.',
      'payment-received': 'Payment received',
      'payment-failed': 'Payment failed',
    },
    'failed-transaction': {
      title: 'Square Is Not Responding',
      content: 'We’re having issues establishing a connection with Square. Please try again.',
      'try-again': 'Try again with Square',
    },
  },
  stripe: {
    'booksy-card-reader': 'Booksy Card Reader',
    'checkout-welcome-modal': {
      title: 'Use Your Card Reader At Checkout',
      description: 'Choose Booksy Card Reader as your payment method during Checkout.',
    },
    'update-app': 'Update app',
    'update-app-warning': 'Update your Booksy App to connect Card Reader.',
    'update-app-warning-m2': 'Update your Booksy App to connect the Stripe Reader M2.',
    onboarding: {
      'about-card-reader-title': 'About Booksy Card Reader',
      'about-card-reader-text': 'Fast, secure payment processing for credit cards and mobile wallets.',
      'onboarding-welcome': 'Complete a few simple steps to start using your Booksy Card Reader to accept payments.',
      'verification-stage': 'Verify your account',
      'order-reader-stage': 'Order your card reader',
      'connect-device-stage': 'Connect your device',
      'first-transaction-stage': 'Complete your first transaction',
      'help-hint': 'Need help?',
      'contact': 'Contact us',
      'having-trouble-connecting': 'Having trouble connecting?',
      'check-troubleshooting-guide': 'Check out our troubleshooting guide',
      'not-able-to-connect': 'Still not able to connect?',
      'try-dns-guide': 'Try our DNS guide',
      'verify-button': 'Verify',
      'update-information-button': 'Update information',
      'order-reader-button': 'Order now',
      'connect-reader-button': 'Connect',
      'your-devices': 'Your devices',
      'allow-bluetooth-to-see-devices': 'List of Your Devices may not be up to date, please allow Bluetooth to show all devices',
      'how-it-works': {
        'header': 'How it works',
        'tab-1': {
          title: 'Using your Card Reader:',
          'point-1': 'Your Card Reader will be listed as a payment option during the Checkout process. Use it for any transaction processed in your Booksy app.',
          'point-2': 'You can also use your Card Reader to process client refunds',
          'point-3': 'For each transaction you\'ll be charged a processing fee of {val}. This includes refunds.',
        },
        'tab-2': {
          title: 'Payouts',
          'point-1': 'We will deposit funds into your account daily.',
          'point-2': 'Please keep in mind that time from transaction to payout could take 2-5 days.',
          'point-3': 'After each payout you\'ll receive an e-mail summarizing all details',
        },
        'tab-3': {
          title: 'Troubleshooting',
          'point-1': 'If you\'re having issues with your Card Reader, first make sure that it\'s turned on',
          'point-2': 'Make sure your Card Reader is connected to the same WiFi network as the device that you\'re using to access Booksy',
          'point-3': 'Power down your Card Reader then try reconnecting it to Booksy',
          'point-4': 'If you\'re still having issues don\'t hesitate to contact our Support Team.',
        },
      },
      'getting-started': {
        'header': 'Getting Your Card Reader',
        'sub-header': 'Securing and setting up a Booksy Card Reader is easy:',
        'point-1': `Start by verifying your account. You'll need to enter bank account details and confirm your identity.`,
        'point-2': `Following verification you can order your Booksy Card Reader.`,
        'point-3': `When you receive your Card Reader, we'll guide you through how to get it set up and connected.`,
      },
      'learn-more': {
        title: 'Learn more',
        'get-paid-title': 'Booksy Card Reader',
        'get-paid-subtitle': "Booksy Card Reader allows you to accept card and mobile wallet payments on the spot. Greater flexibility for customers means it's easier for you to get paid.",
        'cta': 'Get Started',
        'choose-your-reader-title': 'Choose Your Card Reader',
        'costs-info-title': 'No Hidden Costs',
        'costs-info-subtitle': `Transparent rates, no monthly fees. Once you have your Card Reader in hand, you only pay when you're bringing in money.`,
        'fee-amount': '2.55% + $0.10',
        'fee-subtitle': 'Processing fee per transaction',
        pros: {
          'title': 'The Fully Integrated Payment Solution',
          'pro-1': {
            title: 'Streamlined Checkout',
            text: 'Offer your customers a quick and professional Checkout. No switching between apps, just a smooth customer experience. ',
          },
          'pro-2': {
            title: 'One App, For Everything',
            text: 'Booksy Card Reader is fully integrated with your entire Booksy experience. Get booked, get paid, and access reporting – all in one place.',
          },
          'pro-3': {
            title: 'Money, When You Need It',
            text: 'Booksy Card Reader is safer than cash and just as fast. Get free next business day payouts, or Fast Payouts within 30 minutes for a 1% fee.',
            text2: 'Booksy Card Reader is safer than cash and just as fast. Get free next business day payouts, or Fast Payouts within 30 minutes for a {rates} fee.',
          },
          'pro-4': {
            title: "You've Got Options",
            text: "Choose the Booksy Card Reader that suits your business needs whether it's a front desk solution with all the bells and whistles or something compact to process payments on the fly.",
          },
        },
        'chargeback-info': `In the unlikely event one of your customers opens a dispute with their bank you'll be be responsible for a $15 non-refundable chargeback fee.`,
        'get-started-condition': `By clicking “Get Started” you are agreeing to the`,
        'connected-account-agreement': ' Connected Account Agreement.',
        'features': {
          desktop: 'Desktop',
          phone: 'iPhone/Android mobile devices',
          tablet: 'iPad/Android tablet',
          wifi: 'WiFi',
          bluetooth: 'Bluetooth',
          display: 'Display Screen',
          tips: 'Tips on screen',
          wireless: 'Wireless',
        },
      },
      'verify-account': {
        title: 'Account Verification',
        'info-header': 'We need to confirm your account to ensure secure payouts from Booksy. Verification will take 10-15 minutes and will be done via Stripe.',
        info: `Before you can proceed we need to verify your account. Once that's done you'll be able to order your Booksy Card Reader. <br><br>To verify your account you'll need to enter your address, bank account number, Tax ID or SSN, and prove your identity.`,
        'info-1': {
          title: 'Start account verification',
          description: 'You\'ll need a phone number where you can receive text messages (verification codes will be sent) and an email address you have access to. You\'ll use these to log in to your Stripe account in the future too, so don\'t forget which ones you use.',
        },
        'info-2': {
          title: 'Choose the right business category',
          description: 'Are you a Sole Proprietor? An LLC? You\'ll need this information for this step.',
        },
        'info-3': {
          title: 'Confirm your Identity',
          description: 'Gather your personal info (legal name, address, SSN), your business info (legal name, address, Tax ID), and your bank account info (business name, address, routing number, account number) to finish this section.',
        },
        'go-to-verification-process': 'Start Account Verification',
      },
      'verify-account-redirect': {
        'title': 'You will be redirected to Stripe website',
        'wait': 'Wait a few seconds...',
      },
      'reset-account': {
        title: 'Reset Account',
        description: 'If you\'re having trouble receiving the verification code to create your login, reset your account and start over. Make sure you\'re creating your login using a phone number where you can receive text messages, and an email address where you can receive emails.',
        action: 'Reset Account',
      },
      'status-info': {
        pending: {
          title: 'Almost Done',
          text: `Your information is being reviewed. You'll be notified when your account has been verified.`,
          button: 'Got It',
        },
      },
    },
    'onboarding-finished': {
      'update-details': 'Update Your Business Details',
      'order-reader': 'Order Card Reader',
      connect: 'Connect New Card Reader',
      'fast-payout': 'Fast Payout',
    },
    tile: {
      subtitle: 'Powered by Stripe. Offer fast, secure payment processing for clients that want to pay in person.',
      'badge-new': 'New',
      statuses: {
        'turned-off': 'Turned Off',
        'verification-pending': 'Verification Pending',
        'pending': 'Pending',
        'verified': 'Verified',
        'not-verified': 'Not Verified',
        'device-ordered': 'Device Ordered',
        'connected': 'Connected',
        'not-connected': 'Not Connected',
        'blocked': 'Blocked',
        'no-location': 'Location Access Needed',
      },
    },
    modals: {
      subscription: {
        title: 'Enable Card Processing',
        text1: 'Booksy Card Reader allows you to process credit cards and mobile wallets - quickly and safely. Follow the simple setup and start enjoying the fully integrated checkout experience.',
        text2: 'In order to enable card processing and use a Booksy Card Reader, you need to have an active subscription to Booksy. Choose a subscription plan to continue.',
      },
      disconnect: {
        title: 'Disconnect Your Other Card Reader?',
        text: 'Another Reader is in use. In order to connect your new Reader we\'ll need to disconnect you from {label}.',
      },
      location: {
        title: 'Location Access Needed',
        text1: 'In order to process payments with Booksy Card Reader, you must allow Booksy to access your location while using the app.',
        text2: 'Follow these simple steps to allow access:',
        stages: {
          settings: 'Visit phone settings',
          access: 'Give Booksy App access to your location',
        },
      },
    },
    checkout: {},
    'failed-transaction': {
      title: 'Transaction failed',
      text: 'Something went wrong. Please try again.',
      'try-again': 'Try again with Stripe',
    },
    'register': {
      title: 'Connect Card Reader',
      'name-reader-label': 'Card Reader Name',
      'empty-label-error-message': 'Field cannot be empty',
      'registration-code-label': 'Your code',
      'pairing-code-label': 'Pairing Code',
      'missing-registration-code-error-message': 'Missing registration code',
      'open-tutorial': 'Open tutorial',
      'power-reader': {
        title: 'Power On Your Reader',
        description: 'Connect the adapter to the port at the top of your Reader. Wait while the device turns on.',
      },
      'connect-to-internet': {
        title: 'Connect to the Internet',
        description: 'To set up a new device, follow the prompts to connect to WiFi. If you need to start over, press the red X on the keypad.',
        note: 'Your Booksy account and this device must be connected to the same WiFi network.',
        description2: 'To connect to WiFi, swipe your finger from left to right across the display screen. Select Settings and choose the network you\'d like to connect to.<br><br>Remember, the device you\'re using your Booksy account from and your Card Reader must be connected to the same WiFi network.<br><br>If you are already connected to a WiFi network but want to switch to a different one, go to WiFi settings and choose the new network. If you connect to a new network, your Card Reader will be disconnected from any previous network. They can only be connected to one network at a time.',
        'how-it-works': {
          title: 'How do I connect my BBPOS WisePOS E?',
          hints: [
            'Power on your Card Reader',
            'Tap Connect to Wifi ',
            'Your Booksy Card Reader and your Booksy app must be connected to the same network, and that network must be password protected.',
            'After connecting to Wifi, you may be prompted to update your Card Reader. ',
          ],
        },
      },
      'name-reader': {
        title: 'Name Your Card Reader',
        description: 'Assigning a name to your Card Reader can help you stay organized, especially if you use more than one for your business.',
        'how-it-works': {
          title: 'Naming your Card Reader',
          hints: [
            'Naming your Card Reader can be fun, practical, whatever works for you. The name you choose will appear every time you connect your Card Reader, and your Booksy app may refer to your Card Reader by name.',
            'It does not affect how your card reader works, but it can help you stay organized if you have multiple card readers associated with your account.',
          ],
        },
      },
      sequence: {
        title: 'Enter 0-7-1-3-9 on Your Reader',
        description: 'After entering the key sequence, a registration code will appear on the display screen. If it doesn\'t, enter the key sequence again.',
        description2: 'Swipe right across the screen of your Card Reader. Tap Settings, and a keypad should appear. Enter the admin PIN 0-7-1-3-9.',
        'how-it-works': {
          title: 'Admin PIN',
          hints: [
            'The Admin PIN 0-7-1-3-9 will never change. This will be the PIN you use every time you access the Settings menu or change your WiFi connection on your Card Reader.',
            'If your Staff Members need to complete these tasks or if they may need to troubleshoot connectivity issues, they\'ll need to have access to this Admin PIN.',
          ],
        },
      },
      'registration-code': {
        title: 'Enter Registration Code',
        description: 'The registration code should appear on the display screen on your Reader. If it doesn\'t, enter the key sequence on your Reader again.',
      },
      'choose-reader': {
        title: 'Choose Card Reader',
        description: 'Select the Reader with the serial number that corresponds to the device you\'re using. Locate the serial number on the back of your Reader or on the outside of the box. It will be labeled S/N and will be listed in the format 123-456-789.',
      },
      'battery': {
        title: 'Rechargeable Battery',
        description: 'Open the battery compartment for the BBPOS<br>WisePOS E by pulling the bottom left corner up and removing the cover. Place the rechargeable battery in the compartment and snap the cover back into place.',
        'how-it-works': {
          title: 'How to open battery compartment?',
          hints: [
            'When opening the battery compartment, it may require a strong pull to remove the back cover from the device. Pull up on the indentation in the bottom left corner.',
            'When installing the battery, ensure that the gold connectors on the battery line up with the gold connectors in the battery compartment.',
          ],
        },
      },
      'power-on': {
        title: 'Power on Your Reader',
        description: 'Hold down the power button on the right-hand side until the screen turns on.<br><br>If the battery is low, the Card Reader won\'t turn on when you hold down the Power button. To recharge the battery, plug the charging cable into the port with the lighting bolt on your device.',
        'description-m2': 'Make sure your Stripe Reader M2 is charged. Turn on by pressing and holding the power button on the right side of the device. The status LEDs turn on and the reader beeps twice. The reader waits for a Bluetooth connection for five minutes before turning off.',
        'how-it-works': {
          title: 'How to power on Card Reader',
          hints: [
            'Charge your device each night so it\'s fully charged and ready to go when you need it. The Card Reader won\'t turn on if the battery is low.',
            'When you power on the Card Reader, the battery icon in the top right of the screen will indicate the charge level.',
            'When you power on the Card Reader, the battery icon in the top right of the screen will indicate the charge level.',
            'You can charge your Card Reader using the micro-USB cable (wall adapter not included) or you can purchase the WisePOS Dock and charge the Card Reader while it\'s mounted in the dock.',
            'While the Card Reader is charging, you can check the charge level by pressing the power button.',
            'Once the Card Reader is powered on, you can use the power button to put the Card Reader to sleep, or power it off.',
          ],
        },
      },
      'generate-code': {
        title: 'Generate Pairing Code',
        description: 'Tap Generate Pairing Code in the Settings Menu.<br>A pairing code should appear on the display screen of your Card Reader.',
        'how-it-works': {
          title: 'Generating pairing code',
          hints: [
            'The pairing code allows your Card Reader to connect to your Booksy app so you can process payments all within the app. No more back and forth.',
            'The pairing code will be a series of 3 unrelated words. It will appear on the Card Reader display screen and you\'ll need to type it into the text box in the Booksy app.',
            'Each code will be valid only once. Each time you connect a device, you\'ll need to generate and enter a different pairing code.',
          ],
        },
      },
      'pairing-code': {
        title: 'Enter Pairing Code',
        description: 'Enter the pairing code from your Card Reader on your Booksy device.<br><br>If you didn\'t get a pairing code, tap Generate Pairing Code again.',
      },
      'is-pairing-code': {
        title: 'Do you have a Pairing Code for your Card Reader?',
        description: 'To get your Pairing Code, tap Generate Pairing Code in the Settings Menu on your Card Reader.<br><br>A three-word code should appear on the display screen.',
        'got-my-code': 'Got my code',
        'no-code': 'No code',
      },
      'reader-processing': {
        title: 'We\'re working on your Card Reader',
        description: 'This will take a moment. When the registration and/or update is complete, you\'ll see the display screen on your WisePOS switch to the Booksy logo. From there, you can start the process of connecting your Card Reader to your Booksy app.',
      },
      'charge': {
        title: 'Charge Your Reader',
        description: 'Connect the charging cable to the reader and charge it for two hours before initial use. Use the charging cable provided in the reader box.',
      },
      'check-battery': {
        title: 'Check the Battery Level',
        description: 'When the Stripe Reader M2 is on, you can press and release the power button once to check the battery level. The LEDs on top of the reader show the current status. You will be able to see the battery level of your device in Settings - Payment Types - Booksy Card Reader',
        fullCharged: 'Full Charged',
        partlyCharged: '{state} charged',
        flashing: 'Flashing = charging',
        leds: 'Leds',
        meaning: 'Meaning',
      },
      'bluetooth': {
        title: 'Enable Bluetooth on your tablet',
        description: 'The status light on the left side of your Reader will turn on when it\'s ready. Do not connect the Reader directly through your device\'s Bluetooth settings.',
      },
      'readers-list': {
        title: 'Choose Card Reader',
        description: 'Select the Reader you want to connect.',
      },
      modals: {
        bluetooth: {
          title: 'Connect to Bluetooth',
          'description-reader-list': 'Please allow Booksy Card Reader to access Bluetooth and turn it on to display your devices and their status.',
          stages: {
            settings: 'Go to your tablet settings',
            'turn-on-bluetooth': 'Turn Bluetooth on',
            access: 'Give bluetooth access',
          },
        },
      },
    },
    'connect': {
      hint: 'Don\'t worry. <strong>Connecting your Card Reader</strong> is quick and easy and we\'ll walk you through the process. <strong>Go to FAQ section to learn more.</strong>',
      choose: 'Which Card Reader do you have?',
      'connected-label': 'Connected',
      'connect-button': 'Connect',
      'checking-updates': {
        title: 'Checking for updates...',
        description: 'Searching for the availability of software update for Stripe Reader M2',
      },
      update: {
        title: 'Updating Software',
        subtitle: '{progress}% complete',
        description: `Your Stripe Reader M2 update can take up to 15 minutes.<br /><br />Don't turn off Booksy or Bluetooth on your device while the update is in progress.<br />We will let you know when it's done.`,
        continue: 'Continue using app',
        updating: 'Updating',
      },
      failure: {
        title: 'Connection failed',
        description: 'We were unable to connect your Card Reader to Booksy. Please try again.',
      },
      success: {
        title: 'Your Card Reader is Connected',
        description: 'Your Booksy Card Reader is set up and ready to process payments.<br><br>During the Checkout process you\'ll now see Booksy Card Reader listed as a payment method.',
      },
      'unknown-reader': 'Unknown reader',
    },
    'connection-status': {
      loader: {
        title: 'Connecting...',
        description: {
          wifi: 'This could take a few minutes.',
          bluetooth: 'This could take a few minutes. The LEDs will flash a few times when your Card Reader is connected.',
        },
      },
    },
    discover: {
      loader: {
        title: 'Searching for available readers …',
      },
      'no-available-readers': {
        title: 'No Card Reader Found',
        description: 'We didn\'t find a Card Reader but don\'t worry.<br />Check these things and try again.<br /><br />Is the Card Reader powered on?<br />Does the device you\'re using have access to your location while using the app?<br />Is your Internet connection and/or Bluetooth working?',
        'description-bluetooth': 'We didn\'t find a Card Reader but don\'t worry.<br />Check these things and try again.<br /><br />Is your Bluetooth working?<br>Is the device you\'re using have access to your location while using the app?<br>Is the Card Reader powered on?',
        actions: {
          'try-later': 'Try later',
        },
      },
    },
    blocked: {
      title: 'Card Processing Blocked',
      description: 'Card processing has been disabled for your account. Please contact our Support Team for assistance.',
    },
    busy: 'Temporary busy',
    'turned-off': 'Turned off',
    'start-account-verification': {
      title: 'Account Verification',
      'express-info': 'We need to confirm your account to ensure secure payouts from Booksy. Verification will take 10-15 minutes and will be done via Stripe.',
      'express-info-us-1': {
        title: '1. Start account verification',
        description: 'You\'ll need a phone number where you can receive text messages (verification codes will be sent) and an email address you have access to. You\'ll use these to log in to your Stripe account in the future too, so don\'t forget which ones you use.',
      },
      'express-info-us-2': {
        title: '2. Choose the right business category',
        description: 'Are you a Sole Proprietor? An LLC? You\'ll need this information for this step.',
      },
      'express-info-us-3': {
        title: '3. Confirm your Identity',
        description: 'Gather your personal info (legal name, address, SSN), your business info (legal name, address, Tax ID), and your bank account info (business name, address, routing number, account number) to finish this section. ',
      },
      'custom-info': 'We need to confirm your account to ensure secure payouts from Booksy. Verification will take a few moments and will be done via Stripe. Here is some important information before you start.',
      'custom-info-us-1': {
        title: '1. Choose the right business type.',
        description: 'Are you operating as an individual, company, non-profit, or government entity? For all business types other than individual, you may need to identify your legal business structure (i.e. LLC, Sole Proprietorship, etc.).',
      },
      'custom-info-us-2': {
        title: '2. Confirm your identity',
        description: 'To start processing payments and receiving payouts, you’ll be asked to provide additional information about you and your business. For individuals you’ll need your legal name, SSN, and date of birth. For companies, you’ll need your legal business name and Tax ID*. In some cases, you may be asked to provide additional proof of identification such as a photo ID.',
        info: '*non-US citizens may enter their ITIN number. ITIN number should be added into the TaxID/EIN/SSN text field when completing the KYC form.',
      },
      'custom-info-us-3': {
        title: '3. Provide your payout information',
        description: 'To ensure your payouts are delivered to the right spot, you will be asked to add your bank account and/or debit/credit card. ',
      },
      'custom-info-fr-1': {
        title: '1. Choose the right business type.',
        description: 'Are you operating as an individual, company, non-profit, or government entity? For all business types other than individual, you may need to identify your legal business structure (i.e. LLC, Sole Proprietorship, etc.).',
      },
      'custom-info-fr-2': {
        title: '2. Confirm your identity',
        description: 'To start processing payments and receiving payouts, you’ll be asked to provide additional information about you and your business. For individuals you’ll need your legal name, address, and date of birth. For companies, you’ll need your legal business name, Siren number and address. In some cases, you may be asked to provide additional proof of identification such as a photo ID.',
      },
      'custom-info-fr-3': {
        title: '3. Provide your payout information',
        description: 'To ensure your payouts are delivered to the right spot, you will be asked to add your bank account.',
      },
      'custom-info-pl-1': {
        title: '1. Choose the right business type',
        description: 'Are you operating as an individual or a company? Please remember to onboard yourself according to the business entity type you really are and the information you provided during subscription purchase.',
      },
      'custom-info-pl-2': {
        title: '2. Confirm your identity',
        description: 'To start processing payments and receiving payouts, you’ll be asked to provide additional information about you and your business. For individuals you’ll need your legal name, address, and date of birth. For companies, you’ll need your legal business name,  tax ID and company address. In some cases, you may be asked to provide additional proof of identification such as a photo ID. Make sure you have the necessary documents ready.',
      },
      'custom-info-pl-3': {
        title: '3. Provide your payout information',
        description: 'To ensure your payouts are delivered to the right spot, you will be asked to add your IBAN. In case your verification fails, or some documents are missed, you will need to finalize the KYC process on a secured Stripe view in Account Verification section.',
      },
      'custom-info-es-1': {
        title: '1. Choose the right business type',
        description: 'Are you operating as an individual or a company? Please remember to onboard yourself according to the business entity type you really are and the information you provided during subscription purchase.',
      },
      'custom-info-es-2': {
        title: '2. Confirm your identity',
        description: 'To start processing payments and receiving payouts, you’ll be asked to provide additional information about you and your business. For individuals you’ll need your legal name, address, and date of birth. For companies, you’ll need your legal business name,  tax ID and company address. In some cases, you may be asked to provide additional proof of identification such as a photo ID. Make sure you have the necessary documents ready.',
      },
      'custom-info-es-3': {
        title: '3. Provide your payout information',
        description: 'To ensure your payouts are delivered to the right spot, you will be asked to add your IBAN. In case your verification fails, or some documents are missed, you will need to finalize the KYC process on a secured Stripe view in Account Verification section.',
      },
      'custom-info-ie-1': {
        title: '1. Choose the right business type',
        description: 'Are you operating as an individual or a company? Please remember to onboard yourself according to the business entity type you really are and the information you provided during subscription purchase.',
      },
      'custom-info-ie-2': {
        title: '2. Confirm your identity',
        description: 'To start processing payments and receiving payouts, you’ll be asked to provide additional information about you and your business. For individuals you’ll need your legal name, address, and date of birth. For companies, you’ll need your legal business name,  tax ID and company address. In some cases, you may be asked to provide additional proof of identification such as a photo ID. Make sure you have the necessary documents ready.',
      },
      'custom-info-ie-3': {
        title: '3. Provide your payout information',
        description: 'To ensure your payouts are delivered to the right spot, you will be asked to add your IBAN. In case your verification fails, or some documents are missed, you will need to finalize the KYC process on a secured Stripe view in Account Verification section.',
      },
      'custom-info-gb-1': {
        title: '1. Choose the right business type',
        description: 'Are you operating as an individual or a company? Please remember to onboard yourself according to the business entity type you really are and the information you provided during subscription purchase.',
      },
      'custom-info-gb-2': {
        title: '2. Confirm your identity',
        description: 'To start processing payments and receiving payouts, you’ll be asked to provide additional information about you and your business. For individuals you’ll need your legal name, address, and date of birth. For companies, you’ll need your legal business name,  tax ID and company address. In some cases, you may be asked to provide additional proof of identification such as a photo ID. Make sure you have the necessary documents ready.',
      },
      'custom-info-gb-3': {
        title: '3. Provide your payout information',
        description: 'To ensure your payouts are delivered to the right spot, you will be asked to add your sort code and account number. In case your verification fails, or some documents are missed, you will need to finalize the KYC process on a secured Stripe view in Account Verification section.',
      },
      'action-btn': 'Start Account Verification',
    },
    'pl-individuals-migration-consent': {
      'title': 'Get access to the newest features',
      'description': 'Complete verification now to gain access to these features designed to help you grow your business and ensure access to our newest features as soon as they become available!',
      'feature-list': [
        {
          'title': 'BLIK payments',
          'description': 'Provide your clients with the most popular payment method',
        },
        {
          'title': 'Booksy gift cards',
          'description': 'Join businesses that accept our gift card',
        },
        {
          'title': 'No-Show Protection',
          'description': 'Don\'t lose money due to last-minute cancellations',
        },
      ],
      'instruction': {
        'intro': 'All you need to do is enter your date of birth and click <strong>"Agree."</strong> We will then be able to:',
        'points': [
          'Use your details, such as <strong>full name</strong> and <strong>company address</strong> to enable Mobile Payments',
          '(you can find information about Booksy’s data processing rules <a target="blank" href="https://information-obligation.booksy.com/pl-information-obligation.pdf"><strong>here</strong></a>).',
          'Create an account for you on the Stripe platform - our payment provider.',
        ],
        'after': 'After successful verification, you can start using Mobile Payments and No-show Protection right away, with more features coming soon!',
      },
      'disclaimer': 'By clicking <strong>"Agree"</strong>, you accept <a href="https://stripe.com/en-pl/legal/connect-account" target="blank"><strong><u>Stripe\'s Terms of Service.</u></strong></a><br><br>For fees and commissions, see theTerms of Service of the Booksy Biz app.',
      'disclaimer-iphone': 'By clicking <strong>"Agree"</strong>, you accept <strong><u>Stripe\'s Terms of Service.</u></strong><br><br>For fees and commissions, see the Terms of Service of the Booksy Biz app.',
    },
    'pl-individuals-adyen-migration-consent': {
      'title': 'Important information<br>On October 30, you may lose access to Booksy Payments',
      'description': 'We are changing our Payment Processor to Stripe - a global leader in payment solutions. To continue using our payment features such as Mobile Payments and No-Show Protection, we need your consent to transfer your data to Stripe.',
      'instruction': {
        'intro': 'All you need to do is enter your date of birth and click <strong>"Agree"</strong> before <strong>October 30</strong>. We will then be able to:',
        'points': [
          'Use your details, such as full name and company address for the transfer of your data ',
          '(you can find information about Booksy’s data processing rules <a target="blank" href="https://information-obligation.booksy.com/pl-information-obligation.pdf"><strong>here</strong></a>).',
          'Create an account for you on the Stripe platform - our payment provider.',
        ],
        'after': 'Once your data is transferred, you can continue using Booksy Payments as usual, with more features coming soon!',
      },
    },
    'pl-ceidg-migration-consent': {
      'instruction': {
        'intro': 'All you need to do is confirm your tax ID, enter your date of birth and click <strong>"Agree"</strong>. We will then be able to:',
        'points': [
          'Verify your tax ID number with CEIDG <a target="blank" href="https://ceidg.gov.pl"><strong><u>(ceidg.gov.pl)</u></strong></a> and share it with Stripe to enable Mobile Payments ',
          '(you can find information about Booksy’s data processing rules <a target="blank" href="https://information-obligation.booksy.com/pl-information-obligation.pdf"><strong>here</strong></a>).',
          'Create an account for you on the Stripe platform - our payment provider.',
        ],
        'after': 'After successful verification, you can start using Mobile Payments and No-show Protection right away, with more features coming soon!',
      },
    },
    'pl-ceidg-adyen-migration-consent': {
      'instruction': {
        'intro': 'All you need to do is confirm your tax ID, enter your date of birth and click <strong>"Agree"</strong> before <strong>October 30</strong>. We will then be able to:',
        'points': [
          'Verify your tax ID number with CEIDG <a target="blank" href="https://ceidg.gov.pl"><strong><u>(ceidg.gov.pl)</u></strong></a> and share it with Stripe for the transfer of your data ',
          '(you can find information about Booksy’s data processing rules <a target="blank" href="https://information-obligation.booksy.com/pl-information-obligation.pdf"><strong>here</strong></a>).',
          'Create an account for you on the Stripe platform - our payment provider.',
        ],
        'after': 'Once your data is transferred, you can continue using Booksy Payments as usual, with more features coming soon!',
      },
    },
    'pl-krs-migration-consent': {
      'instruction': {
        'intro': 'All you need to do is confirm your tax ID and click <strong>"Agree."</strong> We will then be able to:',
        'points': [
          'Verify your tax ID number with KRS registry and share it with Stripe to enable Mobile Payments',
          '(you can find information about Booksy’s data processing rules <a target="blank" href="https://information-obligation.booksy.com/pl-information-obligation.pdf"><strong>here</strong></a>).',
          'Create an account for you on the Stripe platform - our payment provider.',
        ],
        'after': 'After successful verification, you can start using Mobile Payments and No-show Protection right away, with more features coming soon!',
      },
    },
    'pl-krs-adyen-migration-consent': {
      'instruction': {
        'intro': 'All you need to do is confirm your tax ID and click <strong>"Agree"</strong> before <strong>October 30</strong>. We will then be able to:',
        'points': [
          'Verify your tax ID number with KRS registry and share it with Stripe for the transfer of your data ',
          '(you can find information about Booksy’s data processing rules <a target="blank" href="https://information-obligation.booksy.com/pl-information-obligation.pdf"><strong>here</strong></a>).',
          'Create an account for you on the Stripe platform - our payment provider.',
        ],
        'after': 'Once your data is transferred, you can continue using Booksy Payments as usual, with more features coming soon!',
      },
    },
    'us-effortless-kyc': {
      'title': 'Get access to new features!',
      'description': 'Complete a quick verification to unlock our best features for growing your business, and gain first access to brand new features immediately after launch.',
      'feature-list': [
        {
          'title': 'Tap To Pay',
          'description': 'Accept contactless payments from physical cards and digital wallets – no extra hardware required.',
        },
        {
          'title': 'No-Show Protection',
          'description': 'Enable deposits and cancellation fees to limit no-shows, late cancellations, and prevent revenue loss.',
        },
        {
          'title': 'Partner Gift Cards',
          'description': 'Create Partner Gift Cards  that clients can purchase through Booksy allowing more clients to discover your business.',
        },
      ],
      'instruction': 'To access these great features, enter your details below depending on the type of business you operate as and click <strong>"Agree".</strong><br><br>This will create you an account on the Stripe platform - our payment provider.<br><br>Once you have successfully completed your verification, you can start using <strong>Partner Gift Cards</strong>, <strong>Tap to Pay</strong>, <strong>Mobile Payments</strong> and <strong>No-Show Protection.</strong>',
      'disclaimer': 'By clicking <strong>"Agree"</strong>, you accept <a href="https://stripe.com/legal/connect-account" target="blank"><strong><u>Stripe\'s Terms of Service.</u></strong></a><br><br>Your data will be processed as described in <a href="https://stripe.com/privacy" target="blank"><strong>Stripe\'s Privacy Policy</strong></a> and <a href="https://biz.booksy.com/en-us/privacy-policy#privacy-policy" target="blank"><strong>Booksy\'s Privacy Policy.</strong></a><br><br>For fees and commissions, see the Terms and Conditions of the Booksy Biz application.',
      'disclaimer-iphone': 'By clicking <strong>"Agree"</strong>, you accept <strong><u>Stripe\'s Terms of Service.</u></strong><br><br>Your data will be processed as described in <strong>Stripe\'s Privacy Policy</strong> and <strong>Booksy\'s Privacy Policy.</strong><br><br>For fees and commissions, see the Terms and Conditions of the Booksy Biz application.',
      'disclaimer-array': [
        'By clicking <strong>"Agree"</strong>, you accept <a href="https://stripe.com/legal/connect-account" target="blank"><strong>Stripe\'s Terms of Service.</strong></a><br><br></br>',
        'Your data will be processed as described in <a href="https://stripe.com/privacy" target="blank"><strong>Stripe\'s Privacy Policy</strong></a> ',
        'and <a href="https://biz.booksy.com/en-us/privacy-policy#privacy-policy" target="blank"><strong>Booksy\'s Privacy Policy.</strong></a><br><br>For fees and commissions, see the Terms of Service of the Booksy Biz application.',
      ],
      'tabs': [
        'Individual',
        'Company',
      ],
      'info': 'If you have an EIN / ITIN number, please select Company from the options above.',
      'info-individual': 'If you run your business under your own name as individual select Individual from the options above.',
    },
    'booksy-gift-cards-promotion': {
      'title': 'Booksy Gift Cards now available!',
      'description': 'Clients can now use the Gift Card in over 15,000 businesses on Booksy, but your business isn\'t one of them—yet.<br><br>Complete a quick verification process to join and start earning more. The commission fee is just 3% per transaction.',
      'actions': {
        'accept': 'Get started',
      },
    },
    'kyc-loader': [
      {
        'title': 'Just 30 seconds more!',
        'description': 'We’re enabling Booksy Payments for you. Let us tell you more about them.',
      },
      {
        'title': 'No show clients?',
        'description': 'Enable No-Show Protection to protect your time and money against missed appointments.',
      },
      {
        'title': 'More ways to earn',
        'description': 'Booksy Gift Cards offer you the opportunity to expand your business to even more clients.',
      },
      {
        'title': 'Check out appointments with BLIK',
        'description': 'Provide your clients with the most popular cashless payment method and check out appointments even easier.',
      },
      {
        'title': 'Next-day payouts',
        'description': 'Client payments will be paid out to your bank account on the next business day.',
      },
      {
        'title': 'Secure transactions',
        'description': 'Our payment processor is Stripe - a global leader in payment solutions.',
      },
    ],
    'kyc-loader-us': [
      {
        'title': 'Just 30 more seconds!',
        'description': 'We are enabling Booksy Payments for you. Find out how you can use them.',
      },
      {
        'title': 'Are clients forgetting appointments?',
        'description': 'Turn on deposits and cancellation fees to protect your valuable time and money',
      },
      {
        'title': 'Expand your earning potential',
        'description': 'Increase your profits with Partner Gift Cards ',
      },
      {
        'title': 'Speed up payments with Tap to Pay',
        'description': 'Provide clients with a new cashless payment method to make payments quick and seamless.',
      },
      {
        'title': 'Next day payouts',
        'description': 'Receive funds from client deposits to your account as early as the next working day.',
      },
      {
        'title': 'Secure transactions',
        'description': 'Our payment operator is the Stripe platform - a global leader in payment solutions. Your money is safe!',
      },
    ],
    'effortless-kyc-status': {
      'success': {
        'title': 'Booksy payments is now available!',
        'description': 'Your verification has been completed successfully and you can now use Booksy Payments.<br><br>To allow us to transfer client payments to you, you must also add a bank account for payouts by going to:<br><br><strong>Settings > Payments & Checkout > Payout settings.</strong>',
      },
      'pending': {
        'title': 'We need more time',
        'description': 'We need a little more time to enable Booksy Payments on your account. When the process is complete and Booksy Payments are available to you we will inform you. In the meantime, you can use the app normally.',
      },
      'missing-info': {
        'title': 'Additional data required',
        'description': 'To enable Booksy Payments, Stripe requires some additional data.<br><br> To allow us to transfer client payments to you, you must also add a bank account for payouts by going to:<br></strong>Settings > Payments & Sales > Payout Settings</strong>',
      },
      'disclaimer': 'Fees apply for transactions as specified in the <a href="{link}" target="blank"><strong><u>Terms of Service</u></strong></a> and the price list below.',
      'disclaimer-iphone': 'Fees apply for transactions as specified in the <strong><u>Terms of Service</u></strong> and the price list below.',
      'features': {
        'blik': {
          'title': 'BLIK payments',
          'description': 'Fee per mobile payment and refund transaction',
        },
        'booksy-gift-cards': {
          'title': 'Booksy Gift Cards',
          'description': 'Fee for Booksy Gift Card processing',
          'fees': '3% of gross transaction value', // to be modified - this should NOT be stored in front app
        },
        'no-show': {
          'title': 'No-Show Protection',
          'description': 'Fee per mobile payment and refund transaction',
        },
        'mobile-payments': {
          'title': 'Mobile Payments',
          'description': 'Fee per mobile payment and refund transaction',
        },
        'tap-to-pay': {
          'title': 'Tap to Pay',
          'description': 'Fee per Tap to Pay and refund transaction',
        },
        'booksy-card-reader': {
          'title': 'Booksy Card Reader',
          'description': 'Fee per Card Reader payment and refund transaction',
        },
        'e-gift-cards': {
          'title': 'Partner Gift Cards',
          'description': 'Fee per mobile payment and refund transaction',
        },
      },
      'gross': 'gross',
      'complete-details': 'Complete details',
    },
    'restricted-access': {
      'title': 'Action required to continue using Booksy Payments',
      'description': 'Please provide the missing information required by Stripe to continue processing payments through Booksy.',
      'action': 'Update account verification',
    },
  },
  'birthday-field': {
    'placeholder': 'Date of birth',
    'required': 'Required',
  },
  'first-name-field': {
    'placeholder': 'First name',
  },
  'last-name-field': {
    'placeholder': 'Last name',
  },
  'nip-field': {
    'placeholder': 'NIP number',
    'disclaimer': 'NOTE! If the tax ID is incorrect, contact us on chat.',
  },
  'company-field': {
    'placeholder': 'Company name',
  },
  transactions: {
    title: 'All Transactions',
    subtitle: 'Access your entire transaction history, easily search and view transaction details, and check transaction status',
  },
  'two-factor-authentication': {
    'resend': 'Resend code',
    'verification-code': 'Verification code',
    'resend-toast': 'The new code has been sent',
    'banned-title': 'Verification failed - try again later',
    'too-short': 'Code too short',
    'error': 'Add the OTP sent to your email to finish updating.',
  },
  'booksy-gift-cards': {
    'tile-statuses': {
      'new': 'New',
      'verification-pending': 'Verification pending',
      'accepted': 'Active',
      'turned-off': 'Turned off',
    },
  },
  'platform-fee': {
    'title': 'Platform Fee Settings',
    'description': 'Decide who covers the transaction fee for payments processed with Booksy Payments.',
    'items': {
      'client-covers-the-fee': {
        'title': 'Client covers the fee',
        'description': 'Your client pays a {fee} platform fee, so you pay no transaction fee.',
        'hint': '<strong>Example:</strong> <br>For a {price} service, the client pays {total}. You receive {price} in your payout, and the {fee} will cover the transaction fees.',
      },
      'split-fee-with-client': {
        'title': 'Split fee with client',
        'description': 'You pay a {merchantFee} transaction fee, and your client pays the remaining {clientFee}.',
        'hint': '<strong>Example:</strong> <br>For a {price} service, your client pays {total} at checkout. You receive {payout} in your payout, as your {fee} portion of the transaction fee has been deducted.',
      },
      'you-cover-the-fee': {
        'title': 'You cover the fee',
        'description': 'You cover the standard transaction fee, and no platform fee is added for your clients.',
        'hint': '<strong>Example:</strong> <br>For a {price} service, your client pays {price} at checkout. If the transaction fee is {fee}, your payout would be {total}. The actual fee varies depending on the payment method.',
      },
    },
  },
  'basket-status': {
    'pending': 'Pending',
    'action-required': 'Action Required',
    'success': 'Paid',
    'failed': 'Failed',
    'canceled': 'Cancelled',
    'sent-for-refund': 'Sent for refund',
    'refunded': 'Refunded',
    'chargeback': 'Chargeback',
    'chargeback-reversed': 'Chargeback Reversed',
    'second-chargeback': 'Second Chargeback',
  },
  'basket-payment-status': {
    'pending': 'Pending',
    'action-required': 'Action Required',
    'success': 'Paid',
    'failed': 'Failed',
    'canceled': 'Cancelled',
  },
}
